import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'clsx';
import { Typography } from "../../foundation/typography/typography";
import { AttentionFilled16Icon } from "../../assets/icons/ah/attention-filled-16";
import css from "./error-message.module.css";
/**
 * The error message, displayed when something goes wrong
 * @prop text: string - The text in the error message
 * @returns the error message with the AttentionFilled icon
 */
const ErrorMessage = ({ className, text, ...restProps }) => (_jsxs("label", { className: classNames(css.root, className), "aria-label": `Error: ${text}`, ...restProps, children: [_jsx("div", { className: css.icon, children: _jsx(AttentionFilled16Icon, { "aria-hidden": true }) }), _jsx(Typography, { className: css.text, variant: "body-regular", children: text })] }));
ErrorMessage.displayName = 'ErrorMessage';
export { ErrorMessage };
